import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Accordion from '@material-ui/core/Accordion'
import { makeStyles } from '@material-ui/core/styles'

import {
  Title, ContentContainer, CustomDetails, CustomSummary,
} from './styled'

const mobileStyles = makeStyles(() => ({
  root: {
    position: 'unset',
    width: '100%',
    borderBottom: 'solid 1px #eeeeee',
    borderRadius: 'unset !important;',
    minHeight: 'unset',
    margin: '0 !important;',
  },
}))

const desktopStyles = makeStyles(() => ({
  root: {
    position: 'unset',
  },
}))

const CustomAccordion = ({
  title, children, isMobile, expanded,
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded)
  const classes = isMobile ? mobileStyles() : desktopStyles()
  return (
    <Accordion
      style={{
        boxShadow: isMobile ? 'unset' : '0 1px 15px 1px rgba(69, 65, 78, 0.08)',
        borderRadius: '12px',
        marginBottom: '8px',
      }}
      expanded={isExpanded}
      className={classes.root}
    >
      <CustomSummary
        onClick={() => {
          setIsExpanded(!isExpanded)
        }}
        className="filter-icon"
        expandIcon={(
          <i
            className="zmdi zmdi-chevron-down"
          />
        )}
      >
        <Title>
          {title}
        </Title>
      </CustomSummary>
      <CustomDetails>
        <ContentContainer>
          {children}
        </ContentContainer>
      </CustomDetails>
    </Accordion>
  )
}

CustomAccordion.defaultProps = {
  isMobile: false,
  expanded: true,
}

CustomAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool,
  expanded: PropTypes.bool,
}

export default CustomAccordion
